import Vue from 'vue'
import Vuex from 'vuex'

import Data from "./modules/Data";
import Product from "./modules/Product";
import ProductHospitalVer from "./modules/ProductHospitalVer";
import User from "./modules/User";
import Statistics from "./modules/Statistics";
import Health from "./modules/Health";
import MessageQueue from "./modules/MessageQueue";
import Qualification from "./modules/Qualification";
import Promotions from "./modules/Promotions";
import ExportTask from "./modules/ExportTask";

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Data,
    Product,
    ProductHospitalVer,
    User,
    Statistics,
    Health,
    MessageQueue,
    Qualification,
    Promotions,
    ExportTask,
  },
  state: {
    visitorMode: false,
  },
  mutations: {
    refreshVisitorMode(){
      const profile = sessionStorage.getItem('profile');
      this.state.visitorMode = profile ? JSON.parse(profile).mobile === 'test01' : false;
    }
  }
})
